<template>
  <div class="home" >
    <b-hero is-fullheight>
      <b-hero-head has-text-centered class="page-title">
        <b-title is-1>{{ $t('message.totWasted') }}</b-title>
        <b-title is-3>{{ $t('message.totWastedDescription') }}</b-title>
      </b-hero-head>
      <b-hero-body has-text-centered>
        <b-container>
          <b-columns>
            <b-column v-for="lang in langs" :key="lang.id">
              <router-link :to="{ name: 'game', params: { lang: lang }}">
                <b-title is-1>{{ $t('page.lang.'+lang) }}</b-title>
              </router-link>
            </b-column>
          </b-columns>
        </b-container>
      </b-hero-body>
    </b-hero>
    <modal :isActive="isDisclaimerActive">
      <b-title is-2>{{ $t('page.home.disclaimer.title') }}</b-title>
      <p>
        {{ $t('page.home.disclaimer.description') }}
      </p>
      <b-columns has-text-centered>
        <b-column>
         <b-button is-success @click="toggleDisclaimerOff()">
           {{ $t('page.home.disclaimer.accept') }}
         </b-button>
        </b-column>
        <b-column>
          <a href="https://www.google.com" class="button is-danger">{{ $t('page.home.disclaimer.reject') }}</a>
        </b-column>
      </b-columns>
    </modal>
  </div>
</template>

<script>
import Modal from '@/components/partials/Modal.vue'
export default {
  name: 'Home',
  components: {
    Modal
  },
  data () {
    return {
      isDisclaimerActive: true,
      langs: ['en', 'pt', 'fr']
    }
  },
  methods: {
    toggleDisclaimerOff: function () {
      this.isDisclaimerActive = !this.isDisclaimerActive
    }
  }
}
</script>

<style scoped>

</style>
